<template>
  <div>
    <div class="app-accordion-item">
        <button type="button" class="app-accordion-header" v-b-toggle="'supplier-fiscal-general'">
            <span class="app-accordion-header__icon"><AppIcon name="description" /></span>
            <span class="app-accordion-header__title">General</span>
            <AppIcon name="chevron-down" class="app-accordion-header__chevron" />
        </button>
        <b-collapse id="supplier-fiscal-general" visible>
        <div class="app-accordion-body">
                <b-row>
                    <b-col lg="8">
                        <b-form-group label="Razón Social">
                            <b-form-input type="text"
                                        size="sm"
                                        v-model="crud.form.business_name">
                            </b-form-input>           
                        </b-form-group>
                    </b-col>
                    
                    <b-col lg="4">
                        <FindObject render="search"
                                    type="erpFiscalConditions" 
                                    @select-object="loadFiscalConditions($event)" 
                                    :valueID="crud.form.fiscal_conditions_id"                                        
                                    :key="componentKey"/>   
                    </b-col>

                    <b-col lg="6">
                        <FindObject render="search"
                                    type="erpTypeDocuments" 
                                    @select-object="loadTypeDocuments($event)" 
                                    :valueID="crud.form.types_documents_id"
                                    :key="componentKey"/>                       
                    </b-col>
                            
                    <b-col lg="6">
                        <b-form-group label="Número Documento">
                            <b-form-input type="text"
                                        size="md"
                                        v-model="crud.form.documents_number"
                                        @change="validDocumentNumber()">
                            </b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
        </div>
        </b-collapse>
    </div>
    <div class="app-accordion-item">
        <button type="button" class="app-accordion-header" v-b-toggle="'supplier-fiscal-location'">
            <span class="app-accordion-header__icon"><AppIcon name="geo-alt" /></span>
            <span class="app-accordion-header__title">Ubicación</span>
            <AppIcon name="chevron-down" class="app-accordion-header__chevron" />
        </button>
        <b-collapse id="supplier-fiscal-location" visible>
        <div class="app-accordion-body">
                <b-row>
                    <b-col lg="8">
                        <b-form-group label="Dirección">
                            <b-form-input type="text"
                                        size="sm"
                                        v-model="crud.form.address">
                            </b-form-input>           
                        </b-form-group>
                    </b-col>

                    <b-col lg="4">
                        <b-form-group label="Código Postal">
                            <b-form-input type="text"
                                        size="sm"
                                        v-model="crud.form.postal_code">
                            </b-form-input>           
                        </b-form-group>
                    </b-col>

                    <b-col lg="4">
                        <b-form-group label="Ciudad">
                            <b-form-input type="text"
                                        size="sm"
                                        v-model="crud.form.city">
                            </b-form-input>           
                        </b-form-group>
                    </b-col>

                    <b-col lg="4">
                        <b-form-group label="Provincia">
                            <b-form-input type="text"
                                        size="sm"
                                        v-model="crud.form.state">
                            </b-form-input>           
                        </b-form-group>
                    </b-col>

                    <b-col lg="4">
                        <b-form-group label="País">
                            <b-form-input type="text"
                                        size="sm"
                                        v-model="crud.form.country">
                            </b-form-input>           
                        </b-form-group>
                    </b-col>
                </b-row>
        </div>
        </b-collapse>
    </div>
    <div class="app-accordion-item">
        <button type="button" class="app-accordion-header" v-b-toggle="'supplier-fiscal-default'">
            <span class="app-accordion-header__icon"><AppIcon name="settings" /></span>
            <span class="app-accordion-header__title">Por Defecto</span>
            <AppIcon name="chevron-down" class="app-accordion-header__chevron" />
        </button>
        <b-collapse id="supplier-fiscal-default" visible>
        <div class="app-accordion-body">
                <b-row>
                    <b-col lg="6">
                        <FindObject render="search"
                                    type="erpPointsSales" 
                                    display="full_identification"
                                    @select-object="loadPointsSales($event)" 
                                    :valueID="crud.form.points_sales_id"
                                    description="Punto de venta por defecto"
                                    :key="componentKey"/>              
                    </b-col>

                    <b-col lg="6">
                        <FindObject render="search"
                                    type="erpMethodsPayment" 
                                    @select-object="loadMethodsPayment($event)" 
                                    :valueID="crud.form.methods_payment_id"
                                    description="Condición de pago por defecto"
                                    :key="componentKey"/>                                      
                    </b-col>

                    <b-col lg="12">
                        <b-form-group label="Límite de Crédito">
                            <b-form-input type="number"
                                        size="sm"
                                        v-model="crud.form.credit_limit">
                            </b-form-input>           
                        </b-form-group>
                    </b-col>
                </b-row>
        </div>
        </b-collapse>
    </div>
    <div class="app-accordion-item">
        <button type="button" class="app-accordion-header" v-b-toggle="'supplier-fiscal-observations'">
            <span class="app-accordion-header__icon"><AppIcon name="chat-square-text" /></span>
            <span class="app-accordion-header__title">Observaciones</span>
            <AppIcon name="chevron-down" class="app-accordion-header__chevron" />
        </button>
        <b-collapse id="supplier-fiscal-observations" visible>
        <div class="app-accordion-body">
                <b-row>
                    <b-col lg="12">
                        <b-form-group label="Observaciones">
                            <app-textarea id="textarea"
                                            size="sm"
                                            rows="3"
                                            max-rows="6"
                                            v-model="crud.form.observations">
                            </app-textarea>
                        </b-form-group>
                    </b-col>
                </b-row>
        </div>
        </b-collapse>
    </div>
    <div class="text-right">
        <b-button variant="dark" size="sm" @click="save()">
            <AppIcon name="save" class="mr-1" />Guardar
        </b-button>
    </div>
  </div>
</template>
<script>
    import serviceAPI from './../services'
    import Error from '@/handler/error'
    import Session from '@/handler/session'
    import Profiles from '@/config/profiles'
    import Modules from '@/config/modules'
    import Helper from '@/handler/helper'    
    import FindObject from '@/components/inc/find/findObject'  
    import Funciones from '@/handler/funciones'    

    export default {
        components: {
            FindObject,        
        },
        props: [
            'suppliers',
            'suppliersID',
        ],
        data() {
            return {
                // Evita que un doble click cree dos registros fiscales.
                isSaving: false,
                crud: {
                    form: {
                        id: 0,
                        suppliers_id: 0,
                        business_name: '',
                        types_documents: null,
                        types_documents_id: 0,
                        documents_number: '',
                        fiscal_conditions: null,
                        fiscal_conditions_id: 0,
                        address: '',
                        city: '',
                        postal_code: '',
                        state: '',
                        country: '',
                        credit_limit: 0.00,
                        methods_payment: null,
                        methods_payment_id: 0,
                        observations: '',
                        points_sales: null,
                        points_sales_id: 0                        
                    }
                },
                componentKey: 0,
            }
        },        
        watch: {            
            suppliers: function (newQuestion, oldQuestion) {
                this.load()
            }
        },
        methods: {
            load() {                
                if(this.suppliers.data_fiscal){
                    this.crud.form.id = this.suppliers.data_fiscal.id,
                    this.crud.form.suppliers_id = this.suppliers.data_fiscal.suppliers_id,
                    this.crud.form.business_name = this.suppliers.data_fiscal.business_name,                    
                    this.crud.form.documents_number = this.suppliers.data_fiscal.documents_number,                    
                    this.crud.form.address = this.suppliers.data_fiscal.address,
                    this.crud.form.city = this.suppliers.data_fiscal.city,
                    this.crud.form.postal_code = this.suppliers.data_fiscal.postal_code,
                    this.crud.form.state = this.suppliers.data_fiscal.state,
                    this.crud.form.country = this.suppliers.data_fiscal.country,
                    this.crud.form.credit_limit = this.suppliers.data_fiscal.credit_limit,                    
                    this.crud.form.observations = this.suppliers.data_fiscal.observations   
                    
                    this.crud.form.types_documents = this.suppliers.data_fiscal.types_documents,
                    this.crud.form.types_documents_id = this.suppliers.data_fiscal.types_documents_id,
                    
                    this.crud.form.fiscal_conditions = this.suppliers.data_fiscal.fiscal_conditions,
                    this.crud.form.fiscal_conditions_id = this.suppliers.data_fiscal.fiscal_conditions_id,

                    this.crud.form.methods_payment = this.suppliers.data_fiscal.methods_payment,
                    this.crud.form.methods_payment_id = this.suppliers.data_fiscal.methods_payment_id,

                    this.crud.form.points_sales_id = this.suppliers.data_fiscal.points_sales_id
                    this.crud.form.points_sales = this.suppliers.data_fiscal.points_sales                         
                    
                    this.forceRerender()        
                } else {
                    this.crud.form.suppliers_id = this.suppliersID                    
                }                
            },

            save() {
                if (this.isSaving) return
                this.isSaving = true
                let loader = this.$loading.show();                
                
                if (this.crud.form.id) {
                    var result = serviceAPI.editarSalesSuppliers(this.crud.form);
                } else {
                    var result = serviceAPI.agregarSalesSuppliers(this.crud.form);
                }

                result.then((response) => {
                    // Después de crear, los siguientes guardados editan ese registro.
                    if (!this.crud.form.id && response.data && response.data.id) {
                        this.crud.form.id = response.data.id
                    }
                    loader.hide()                    
                    this.isSaving = false
                    this.$awn.success("Datos guardados con éxito");
                })
                .catch(error => {
                    loader.hide()
                    this.isSaving = false
                    this.$awn.alert(Error.showError(error));
                })
            },
             
            loadMethodsPayment (object) {
                if(object){
                    this.crud.form.methods_payment = object
                    this.crud.form.methods_payment_id = object.id             
                } else {
                    this.crud.form.methods_payment = null
                    this.crud.form.methods_payment_id = 0
                }
            },
            loadPointsSales (object) {                    
                if(object){
                    this.crud.form.points_sales = object
                    this.crud.form.points_sales_id = object.id             
                } else {
                    this.crud.form.points_sales = null
                    this.crud.form.points_sales_id = 0
                }
            },              
            loadFiscalConditions (object) {
                if(object){
                    this.crud.form.fiscal_conditions = object
                    this.crud.form.fiscal_conditions_id = object.id             
                } else {
                    this.crud.form.fiscal_conditions = null
                    this.crud.form.fiscal_conditions_id = 0
                }
            },
            loadTypeDocuments (object) {
                if(object){
                    this.crud.form.types_documents = object
                    this.crud.form.types_documents_id = object.id             
                } else {
                    this.crud.form.types_documents = null
                    this.crud.form.types_documents_id = 0
                }
            },             
            forceRerender() {
                this.componentKey += 1;  
            },                        

            validDocumentNumber() {
              this.crud.form.documents_number = this.crud.form.documents_number.replace(/\D/g, '')
              
              if(this.crud.form.types_documents.name == 'CUIT') {
                if(!Funciones.validarCUIT(this.crud.form.documents_number)) {
                  this.$awn.alert("El CUIT es inválido");   
                  this.crud.form.documents_number = ''           
                }            
              }
            }            
        }
    }
</script>
<style scoped>
  .app-accordion-item {
    border: 1px solid var(--app-color-border);
    border-radius: 8px;
    margin-bottom: 12px;
    overflow: hidden;
    background: var(--app-color-surface);
  }
  .app-accordion-header {
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    padding: 10px 14px;
    background: var(--app-color-surface-subtle);
    border: none;
    cursor: pointer;
    font-weight: var(--app-font-semibold);
    font-size: 14px;
    color: var(--app-color-text);
    text-align: left;
  }
  .app-accordion-header__icon {
    display: inline-flex;
    color: var(--app-color-primary);
  }
  .app-accordion-header__title {
    flex: 1 1 auto;
  }
  .app-accordion-header__chevron {
    transition: transform 0.15s ease;
    color: var(--app-color-text-muted);
  }
  .app-accordion-header.collapsed .app-accordion-header__chevron {
    transform: rotate(-90deg);
  }
  .app-accordion-body {
    padding: 14px;
    border-top: 1px solid var(--app-color-border);
  }
</style>
